var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-5 sm:flex sm:items-center sm:justify-between mb-10 bg-white rounded-lg"},[_c('h1',{staticClass:"text-gray-800 text-3xl tracking-widest"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"mt-3 flex justify around sm:mt-0 sm:ml-4"},[_vm._t("more")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }